import { CanvasJSON } from '@doer/frontend-components/creativity-editor';
import { ESPN_HEROS_BASE_URL } from '../urls';

export const espnHero3840x2160: CanvasJSON = {
  version: '7.1.0',
  objects: [
    {
      cropX: 0,
      cropY: 0,
      pieceId: 'background',
      type: 'Image',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 1920,
      top: 1080,
      width: 3840,
      height: 2160,
      fill: 'rgb(0,0,0)',
      stroke: null,
      strokeWidth: 0,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 1,
      scaleY: 1,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0,
      src: `${ESPN_HEROS_BASE_URL}/ligue1/backgrounds/3840x2160.png`,
      crossOrigin: 'anonymous',
      filters: [],
      selectable: false,
      evented: false
    },
    {
      cropX: 0,
      cropY: 0,
      pieceId: 'player-0',
      type: 'Image',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 1823.708,
      top: 1168.1265,
      width: 2048,
      height: 2048,
      fill: 'rgb(0,0,0)',
      stroke: null,
      strokeWidth: 0,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 1.1709,
      scaleY: 1.1709,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0,
      src: `${ESPN_HEROS_BASE_URL}/ligue1/as-monaco/ansu-fati/ansu-fati-002.png`,
      crossOrigin: 'anonymous',
      filters: []
    },
    {
      cropX: 0,
      cropY: 0,
      pieceId: 'player-3',
      type: 'Image',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 3320.7736,
      top: 1156.3097,
      width: 2048,
      height: 2048,
      fill: 'rgb(0,0,0)',
      stroke: null,
      strokeWidth: 0,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 1.1831,
      scaleY: 1.1831,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0,
      src: `${ESPN_HEROS_BASE_URL}/ligue1/auxerre/francisco-sierralta/francisco-sierralta-002.png`,
      crossOrigin: 'anonymous',
      filters: []
    },
    {
      cropX: 0,
      cropY: 0,
      pieceId: 'player-2',
      type: 'Image',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 2795.9573,
      top: 1153.7762,
      width: 2048,
      height: 2048,
      fill: 'rgb(0,0,0)',
      stroke: null,
      strokeWidth: 0,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 1.1818,
      scaleY: 1.1818,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0,
      src: `${ESPN_HEROS_BASE_URL}/ligue1/auxerre/diomande-sinaly/diomande-sinaly-005.png`,
      crossOrigin: 'anonymous',
      filters: []
    },
    {
      cropX: 0,
      cropY: 0,
      pieceId: 'player-1',
      type: 'Image',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 2327.3264,
      top: 1159.2504,
      width: 2048,
      height: 2048,
      fill: 'rgb(0,0,0)',
      stroke: null,
      strokeWidth: 0,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 1.1816,
      scaleY: 1.1816,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0,
      src: `${ESPN_HEROS_BASE_URL}/ligue1/as-monaco/golovin-aleksandr/golovin-aleksandr-004.png`,
      crossOrigin: 'anonymous',
      filters: []
    }
  ],
  background: '#f0f0f0'
};
